"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  data: function data() {
    return {
      $_resizeHandler: null
    };
  },
  mounted: function mounted() {
    this.initListener();
  },
  activated: function activated() {
    if (!this.$_resizeHandler) {
      this.initListener();
    }
    this.resize();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyListener();
  },
  deactivated: function deactivated() {
    this.destroyListener();
  },
  methods: {
    initListener: function initListener() {
      this.$_resizeHandler = this.resize;
      window.addEventListener('resize', this.$_resizeHandler);
    },
    destroyListener: function destroyListener() {
      window.removeEventListener('resize', this.$_resizeHandler);
      this.$_resizeHandler = null;
    },
    resize: function resize() {
      var chart = this.chart;
      chart && chart.resize();
    }
  }
};
exports["default"] = _default;